import {Component, OnInit,} from '@angular/core';
import {OrderService} from "../../services/order/order.service";
import {ActivatedRoute, Router} from "@angular/router";
import {OrderDetailsModel} from "../../models/orders/order-bill.model";
import {OrderBillItem} from "../../models/orders/order-bill-item-sum.model";
import {SplitBillModel} from "../../models/orders/split-bill-model.model";
import {ConfirmationService, MessageService} from "primeng/api";
import {SplitBillItemModel} from "../../models/orders/split-bill-item.model";
import {DialogService} from "primeng/dynamicdialog";
import {TranslateService} from "@ngx-translate/core";
import {PaymentInfoComponent} from "./payment-info/payment-info.component";
import {DiscountTypeEnum} from "../../enums/discount-type.enum";
import {PrinterTypeEnum} from "../../enums/printer-type.enum";
import {DeleteOrderBillComponent} from "./delete-order-bill/delete-order-bill.component";
import {AuthenticationService} from "../../../share-modul/services/authentication/authentication.service";
import {BillReadyForPrintModel} from "../../models/orders/bill-ready-for-print.model";
import {OrderStatusEnum} from "../../enums/order-status.enum";
import {Subject, takeUntil} from "rxjs";
import {ManagerPinDialogComponent} from "../manager-pin-dialog/manager-pin-dialog.component";
import {DeleteOrderBillModel} from "../../models/orders/delete-order-bill.model";
import {DeleteOrderBillItemModel} from "../../models/orders/delete-order-bill-item.model";

interface DropdownOption {
  label: string;
  value: any;
}

@Component({
  selector: 'app-display-bills',
  templateUrl: './display-bills.component.html',
  styleUrls: ['./display-bills.component.scss']
})
export class DisplayBillsComponent implements OnInit {


  public unsubscribe: Subject<void> = new Subject<void>();
  public orderBill: OrderDetailsModel;
  public newSplitBillItems: Array<OrderBillItem> = new Array<OrderBillItem>();
  public venueId: string;
  public tableId: string;
  public activeIndex: number = 0;
  public defaultIndex: number = 0;
  public selectedBill: OrderDetailsModel;
  public splitActive: boolean = false;
  public printerOptions: DropdownOption[];
  public selectedPrinter: any;
  public static FISCAL: string = "ORDER_BILL.FISCAL_PRINTER";
  public static THERMAL: string = "ORDER_BILL.THERMAL_PRINTER";
  public typeOfDiscount: DropdownOption[] = [];
  public selectedTypeOfDiscount: DropdownOption;
  public discountValue: number | undefined;
  public currentWaiter: any;
  public currencySymbol: string = "";
  public selectedItems: Array<string> = new Array<string>();

  constructor(
    public authenticationService: AuthenticationService,
    private router: Router,
    public route: ActivatedRoute,
    public dialogService: DialogService,
    public translate: TranslateService,
    private messageService: MessageService,
    public orderService: OrderService,
    private confirmationService: ConfirmationService

  ) {}

  ngOnInit(): void {
    this.authenticationService.getWaiterProfile()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
      this.currentWaiter = response;
    });
    this.route.params.subscribe(params => {
      this.venueId = params['venue-id'];
      this.tableId = params['table-id'];
    });
    this.getOpenOrderBillsForTable();

    this.printerOptions = [
      { label: DisplayBillsComponent.FISCAL, value: PrinterTypeEnum.Fiscal},
      { label: DisplayBillsComponent.THERMAL, value: PrinterTypeEnum.Thermal}
    ];
  }

  initializeDiscountTypes(){
    this.typeOfDiscount = [
      {label: '%', value: DiscountTypeEnum.Percentage},
      {label: this.orderBill.currencySymbol, value: DiscountTypeEnum.Cash}
    ];
    this.selectedTypeOfDiscount = this.typeOfDiscount[0];
  }

  getOpenOrderBillsForTable(selectedBillId?: string){
    this.orderService.viewOrderBillForTable(this.tableId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        this.orderBill = response;
        if(selectedBillId){
          this.selectedBill = this.getOrderBillById(selectedBillId);
        }else{
          this.selectedBill = this.orderBill;
          this.activeIndex = this.defaultIndex;
        }
        if(this.typeOfDiscount.length == 0){
          this.initializeDiscountTypes();
        }else {
          this.resetDiscountInfo();
        }
        },
        errorResponse => {
          this.router.navigateByUrl("/waiter/"+ this.venueId + '/wtr/' + this.tableId + '/table');
        });
  }

  public changeTab(event: any, tabView: any){
    this.activeIndex = event.index;
    this.selectedBill = <OrderDetailsModel> this.getOrderBillFromTab(this.activeIndex, tabView);
    this.resetDiscountInfo();
  }
  public deleteOrderBill(event: any, tabView: any){
    let billToDelete = <OrderDetailsModel> this.getOrderBillFromTab(event.index, tabView);
    let billToDeleteId = billToDelete.id;

    this.confirmationService.confirm({
      message: this.translate.instant("ORDER_BILL.DELETE_BILL_TEXT"),
      acceptLabel: this.translate.instant("DELETE").toUpperCase(),
      rejectLabel: this.translate.instant("CANCEL").toUpperCase(),
      defaultFocus: "reject",
      accept: () => {
        this.proceedDeleteOrderBill(billToDeleteId);
      }
    });
  }
  proceedDeleteOrderBill(billToDeleteId: string){
     const ref = this.dialogService.open(ManagerPinDialogComponent, {
        data: {
          venueId : this.venueId,
          pinConfirmationOption: true
        },
        showHeader: false,
        width: '100%',
        height: '100%',
        styleClass: "manager_pin_delete"
      });

      ref.onClose.subscribe((response: any) => {
        if(response) {
          let bill = new DeleteOrderBillModel();
          bill.orderBillId = billToDeleteId;
          bill.venueId = this.venueId;
          bill.managerPin = response;
          this.requestDeleteOrderBill(bill);
        }
      });
}
  public deleteOrderBillItem(item: OrderBillItem){
    this.confirmationService.confirm({
      message: this.translate.instant("ORDER_BILL.DELETE_BILL_ITEM_TEXT"),
      acceptLabel: this.translate.instant("DELETE").toUpperCase(),
      rejectLabel: this.translate.instant("CANCEL").toUpperCase(),
      defaultFocus: "reject",
      accept: () => {
        this.proceedDeleteOrderBillItem(item);
      }
    });
  }
  proceedDeleteOrderBillItem(item: OrderBillItem){
    const ref = this.dialogService.open(ManagerPinDialogComponent, {
      data: {
        venueId : this.venueId,
        pinConfirmationOption: true
      },
      showHeader: false,
      width: '100%',
      height: '100%',
      styleClass: "manager_pin_delete"
    });

      ref.onClose.subscribe((response: any) => {
        if(response) {
          let billItem = new DeleteOrderBillItemModel();
          billItem.orderBillItemId = item.id;
          billItem.venueId = this.venueId;
          billItem.pin = response;
          billItem.quantity = item.totalQuantity;
          billItem.employeeId = this.currentWaiter.id;
          this.requestDeleteOrderBillItem(billItem)
        }
      });
  }

  requestDeleteOrderBill(orderBillToDelete: DeleteOrderBillModel){
    this.orderService.deleteOrderBill(orderBillToDelete)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
          this.messageService.add({ severity: 'success', summary: this.translate.instant('ORDER_BILL.SUCCESSFUL_DELETE') , life: 2000 });
          this.getOpenOrderBillsForTable();
        },
        error => {
          this.messageService.add({severity: 'error', summary: error.error.Message, life: 2000});
        });
  }
  requestDeleteOrderBillItem(orderBillItemToDelete: DeleteOrderBillItemModel){
    this.orderService.deleteOrderBillItem(orderBillItemToDelete)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
          this.messageService.add({ severity: 'success', summary: this.translate.instant('ORDER_BILL.SUCCESSFUL_ITEM_DELETE') , life: 2000 });
          this.getOpenOrderBillsForTable(this.selectedBill.id);
        },
        error => {
          if(error.error.StatusCode == -307){
            this.messageService.add({severity: 'error', summary: this.translate.instant("INFO.ACTION_NOT_AUTHORIZED"), life: 2000});
          }else{
            this.messageService.add({severity: 'error', summary: "System error", life: 2000});
          }
        });
  }

  public printBill() {
    let printBillModel = new BillReadyForPrintModel();
    printBillModel.orderBillId = this.selectedBill.id;
    printBillModel.venueId = this.venueId;
    printBillModel.discount = this.discountValue == undefined ? 0 : this.discountValue;
    printBillModel.isPercentage = this.selectedTypeOfDiscount.value == DiscountTypeEnum.Percentage;

    if (this.selectedPrinter.value == PrinterTypeEnum.Thermal){
      this.printThermalPrinter(printBillModel);
    }else{
      this.printFiscalPrinter(printBillModel);
    }

  }
  public printThermalPrinter(model: BillReadyForPrintModel){
      this.orderService.printBillThermalPrinter(model)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
        (response) => {
          this.messageService.add({ severity: 'success', summary: this.translate.instant('ORDER_BILL.SUCCESSFUL_PRINT') , life: 2000 });
         // this.getOpenOrderBillsForTable(model.orderBillId);
          this.selectedPrinter = undefined;
        },
        (error) => {
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
          this.selectedPrinter = undefined;
        }
      );
  }
  public printFiscalPrinter(model: BillReadyForPrintModel){
    this.orderService.printBillTFiscalPrinter(model)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
      (response) => {
        this.messageService.add({ severity: 'success', summary: this.translate.instant('ORDER_BILL.SUCCESSFUL_PRINT') , life: 2000 });
        //this.getOpenOrderBillsForTable(model.orderBillId);
        this.selectedPrinter = undefined;
      },
      (error) => {
        this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        this.selectedPrinter = undefined;
      });
  }
  public openPaymentDialog(){
    const ref = this.dialogService.open(PaymentInfoComponent, {
      data: {
        orderBillId: this.selectedBill.id,
        venueId: this.venueId,
        orderBillNumber: this.selectedBill.billNumber,
        currencySymbol: this.selectedBill.currencySymbol,
        currencyShortName: this.selectedBill.currencyShortName,
        totalPriceWithoutTax: this.selectedBill.price,
        totalPriceWithTax: this.selectedBill.priceWithTax
      },
      showHeader: false,
      height: '313px',
      width: '431px',
      styleClass: "payment_info_dialog"
    });
    ref.onClose.subscribe((response: any) => {
      //this.getOpenOrderBillsForTable();
    });
  }
  public increaseNumberOfItemsInSplitBill(item: OrderBillItem){
     let upperLimit = this.orderBill.items.find(billItem => billItem.menuItemId == item.menuItemId)?.totalQuantity;
     if(upperLimit && item.totalQuantity + 1 <= upperLimit) {
       item.totalQuantity += 1;
     }
  }

  public selectItem(item: OrderBillItem){
    if(this.selectedItems.includes(item.menuItemId)){
      this.selectedItems = this.selectedItems.filter(menuItemId => menuItemId != item.menuItemId );
    }else{
      this.selectedItems.push(item.menuItemId);
    }
  }

  initializeBillSplit(){
    this.splitActive = !this.splitActive;
    this.orderBill.items.forEach(item => this.newSplitBillItems.push(Object.assign(new OrderBillItem(), item)));
  }

  finishBillSplit(){
      this.splitActive = !this.splitActive;
      let splitBillItems = this.newSplitBillItems.filter(item => item.totalQuantity != 0 && this.selectedItems.includes(item.menuItemId)).map(item => {
          let splitBill = new SplitBillItemModel();
          splitBill.menuItemId = item.menuItemId;
          splitBill.quantity = item.totalQuantity;
          return splitBill;
      });

      this.orderBill.items.forEach(item => {
        splitBillItems.forEach(splitBillItem => {
          if(item.menuItemId == splitBillItem.menuItemId){
            item.totalQuantity -= splitBillItem.quantity;
          }
        })
      });

      let splitBill = new SplitBillModel();
      splitBill.orderId = this.orderBill.id;
      splitBill.itemsInNewOrderBills = [splitBillItems];

      this.orderService.splitOrderBill(splitBill)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
        response => {
          this.messageService.add({ severity: 'success', summary: this.translate.instant("ORDER_BILL.SPLIT_BILL_SUCCESSFUL"), life: 3000 });
          this.getOpenOrderBillsForTable();
        },
        errorResponse => {
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
          this.getOpenOrderBillsForTable();
        });
      this.newSplitBillItems = new Array<OrderBillItem>();
      this.selectedItems = new Array<string>();
  }

  getOrderBillById(orderBillId: string){
    if (this.orderBill.id == orderBillId){
      return this.orderBill;
    }else{
      return this.orderBill.orderBills.filter(orderBill => orderBill.id == orderBillId)[0];
    }
  }
  resetDiscountInfo(){
    this.discountValue = undefined;
    this.selectedTypeOfDiscount = this.typeOfDiscount[0];
  }
  setDiscountInfo(discount: number, discountType: DiscountTypeEnum){
    this.discountValue = discount;
    this.typeOfDiscount.forEach(type => {
      if(type.value == discountType){
        this.selectedTypeOfDiscount.label = type.label;
        this.selectedTypeOfDiscount.value = discountType;
      }
    });
  }
  checkPrintEnabled(){
    if(this.activeIndex == 0){
      if(this.selectedBill.orderBills.every(orderBill => orderBill.status == OrderStatusEnum.Paid)){
        return this.selectedBill.status < OrderStatusEnum.ReadyForPrint && this.checkDiscount();
      }
      return false;
    }else {
      return this.selectedBill.status < OrderStatusEnum.ReadyForPrint && this.checkDiscount();
    }
  }
  checkDiscount(){
   return this.discountValue == undefined || (this.discountValue && ((this.selectedTypeOfDiscount.value == DiscountTypeEnum.Cash && this.discountValue < this.selectedBill.priceWithTax)
     || (this.selectedTypeOfDiscount.value == DiscountTypeEnum.Percentage && this.discountValue < 100)));
  }

  checkPaymentEnabled(){
    if(this.activeIndex == 0){
      if(this.selectedBill.orderBills.every(orderBill => orderBill.status == OrderStatusEnum.Paid)){
        return this.selectedBill.status == OrderStatusEnum.ReadyForClose || this.selectedBill.status == OrderStatusEnum.ReadyForPrint;
      }
      return false;
    }else {
      return this.selectedBill.status == OrderStatusEnum.ReadyForClose || this.selectedBill.status == OrderStatusEnum.ReadyForPrint;
    }
  }
  checkSplitEnabled(){
    return this.orderBill && this.orderBill.status < OrderStatusEnum.ReadyForPrint;
  }

  cancelSplit(){
    this.splitActive = false;
    this.getOpenOrderBillsForTable();
    this.newSplitBillItems = new Array<OrderBillItem>();
  }

  orderBillDeleteEnabled(orderBill: OrderDetailsModel){
    return orderBill.status <= OrderStatusEnum.Stored && orderBill.orderBills.length == 0 && !this.splitActive;
  }

  orderBillChangeItemsEnabled(orderBill: OrderDetailsModel){
    return orderBill.status <= OrderStatusEnum.Stored && !this.splitActive;
  }

  getOrderBillFromTab(index: number, tabView: any){
    let currentBillNumber = tabView.tabs[index]._header.slice(1);
    if (this.orderBill.billNumber == currentBillNumber){
      return this.orderBill;
    }else{
      return this.orderBill.orderBills.filter(orderBill => orderBill.billNumber == currentBillNumber)[0];
    }
  }


}
